import { ChecklistProgressEntity } from "../../entities/ChecklistEntity";
import { ChecklistRepository } from "../../repositories/ChecklistRepository";

/**
 * Get Checklist Progress Use Case
 * Fetches progress statistics for a checklist
 */
export class GetChecklistProgressUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(month?: string): Promise<ChecklistProgressEntity> {
    return await this.repository.getProgress(month);
  }
}

